import { render, staticRenderFns } from "./gptTechnology.vue?vue&type=template&id=5457c1a0&scoped=true"
import script from "./gptTechnology.vue?vue&type=script&lang=js"
export * from "./gptTechnology.vue?vue&type=script&lang=js"
import style0 from "./gptTechnology.vue?vue&type=style&index=0&id=5457c1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457c1a0",
  null
  
)

export default component.exports